import { render, staticRenderFns } from "./new_leave.vue?vue&type=template&id=5997f292&scoped=true"
import script from "./new_leave.vue?vue&type=script&lang=js"
export * from "./new_leave.vue?vue&type=script&lang=js"
import style0 from "./new_leave.vue?vue&type=style&index=0&id=5997f292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5997f292",
  null
  
)

export default component.exports